import { motion } from "framer-motion";
import { WHATSAPP_URL } from "../App";

const t = {
  es: {
    badge: "OFERTA LIMITADA",
    title: "Escapada de Temporada",
    desc: "Reserva un mínimo de 3 noches entre semana y recibe un 15% de descuento en tu reserva total. Ideal para trabajadores remotos que buscan una brisa del Pacífico.",
    ctaPrimary: "Reclamar Descuento",
    ctaSecondary: "Consultar disponibilidad",
    highlight: "15% OFF",
    highlightSub: "ESPECIAL ENTRE SEMANA",
  },
  en: {
    badge: "LIMITED OFFER",
    title: "Seasonal Escape",
    desc: "Book a minimum of 3 nights during weekdays and receive a 15% discount on your total reservation. Perfect for remote workers seeking a Pacific breeze.",
    ctaPrimary: "Claim Discount",
    ctaSecondary: "Check Availability",
    highlight: "15% OFF",
    highlightSub: "WEEKDAY SPECIAL",
  },
};

export default function SeasonalOffer({ lang }) {
  const tr = t[lang];

  return (
    <section
      id="seasonal-offer"
      data-testid="seasonal-offer-section"
      className="py-20 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="rounded-3xl overflow-hidden border border-[#D4B895]/40 shadow-xl shadow-[#1F3A5E]/5 grid lg:grid-cols-2"
        >
          {/* Text Side */}
          <div className="p-10 lg:p-14 flex flex-col justify-center bg-white">
            <span className="inline-block mb-5 px-4 py-1.5 bg-[#8C5E35]/10 text-[#8C5E35] text-xs font-montserrat font-bold rounded-full tracking-widest w-fit">
              {tr.badge}
            </span>
            <h2
              className="font-montserrat font-extrabold text-[#1F3A5E] text-3xl md:text-4xl leading-tight mb-4"
              data-testid="seasonal-title"
            >
              {tr.title}
            </h2>
            <p className="font-dm-sans text-gray-500 text-base leading-relaxed mb-8 max-w-md">
              {tr.desc}
            </p>
            <div className="flex flex-wrap gap-3">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="seasonal-claim-btn"
                className="inline-flex items-center px-6 py-3 bg-[#1F3A5E] text-white rounded-full font-montserrat font-bold text-sm hover:-translate-y-0.5 hover:shadow-lg hover:shadow-[#1F3A5E]/20 transition-transform duration-200"
              >
                {tr.ctaPrimary}
              </a>
            </div>
          </div>

          {/* Image + Badge Side */}
          <div className="relative min-h-[280px]">
            <img
              src="/images/galeria/P2.jpg"
              alt="Seasonal Offer"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-[#1F3A5E]/40" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-center bg-white/90 backdrop-blur-md rounded-3xl px-10 py-8 shadow-2xl">
                <p className="font-montserrat font-extrabold text-[#1F3A5E] text-6xl leading-none mb-2">
                  {tr.highlight}
                </p>
                <p className="font-montserrat text-[#8C5E35] text-xs font-bold tracking-widest uppercase">
                  {tr.highlightSub}
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
